var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyNumFaultComparison2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg106",
    width: 477.856,
    height: 317.283,
    viewBox: "0 0 358.392 237.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "*{stroke-linejoin:round;stroke-linecap:butt}"))), /*#__PURE__*/React.createElement("g", {
    id: "figure_1",
    transform: "translate(-16.205 -1.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "axes_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "matplotlib.axis_1",
    transform: "translate(.949 -12.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xtick_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_1",
    d: "M51.84 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "line2d_2"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mccc559a24d",
    d: "M0 0v3.5",
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "use2",
    x: 51.84,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text_1",
    transform: "matrix(.1 0 0 -.1 48.659 236.315)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-30",
    d: "M2034 4250q-487 0-733-480-245-479-245-1442 0-959 245-1439 246-480 733-480 491 0 736 480 246 480 246 1439 0 963-246 1442-245 480-736 480m0 500q785 0 1199-621 414-620 414-1801 0-1178-414-1799Q2819-91 2034-91q-784 0-1198 620-414 621-414 1799 0 1181 414 1801 414 621 1198 621",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_3",
    d: "M90.107 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "line2d_4",
    x: 90.107,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "text_2",
    transform: "matrix(.1 0 0 -.1 83.745 236.315)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-35",
    d: "M691 4666h2478v-532H1269V2991q137 47 274 70 138 23 276 23 781 0 1237-428 457-428 457-1159 0-753-469-1171Q2575-91 1722-91q-294 0-599 50Q819 9 494 109v635q281-153 581-228t634-75q541 0 856 284 316 284 316 772 0 487-316 771-315 285-856 285-253 0-505-56-251-56-513-175z",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-35",
    id: "use4"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use5",
    x: 63.623
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_5",
    d: "M128.375 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "line2d_6",
    x: 128.375,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "text_3",
    transform: "matrix(.1 0 0 -.1 118.831 236.315)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-31",
    d: "M794 531h1031v3560L703 3866v575l1116 225h631V531h1031V0H794Z",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-31",
    id: "use6"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use7",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use8",
    x: 127.246
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_7",
    d: "M166.642 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "line2d_8",
    x: 166.642,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "text_4",
    transform: "matrix(.1 0 0 -.1 157.098 236.315)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-31",
    id: "use9"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-35",
    id: "use10",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use11",
    x: 127.246
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_9",
    d: "M204.91 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "line2d_10",
    x: 204.91,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "text_5",
    transform: "matrix(.1 0 0 -.1 195.366 236.315)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-32",
    d: "M1228 531h2203V0H469v531q359 372 979 998 621 627 780 809 303 340 423 576 121 236 121 464 0 372-261 606-261 235-680 235-297 0-627-103-329-103-704-313v638q381 153 712 231 332 78 607 78 725 0 1156-363 431-362 431-968 0-288-108-546-107-257-392-607-78-91-497-524-418-433-1181-1211",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-32",
    id: "use12"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use13",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use14",
    x: 127.246
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_11",
    d: "M243.177 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "line2d_12",
    x: 243.177,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "text_6",
    transform: "matrix(.1 0 0 -.1 233.633 236.315)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-32",
    id: "use15"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-35",
    id: "use16",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use17",
    x: 127.246
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_13",
    d: "M281.444 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "line2d_14",
    x: 281.444,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "text_7",
    transform: "matrix(.1 0 0 -.1 271.9 236.315)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-33",
    d: "M2597 2516q453-97 707-404 255-306 255-756 0-690-475-1069Q2609-91 1734-91q-293 0-604 58T488 141v609q262-153 574-231 313-78 654-78 593 0 904 234t311 681q0 413-289 645-289 233-804 233h-544v519h569q465 0 712 186t247 536q0 359-255 551-254 193-729 193-260 0-557-57-297-56-653-174v562q360 100 674 150t592 50q719 0 1137-327 419-326 419-882 0-388-222-655t-631-370",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-33",
    id: "use18"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use19",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use20",
    x: 127.246
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_15",
    d: "M319.712 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "line2d_16",
    x: 319.712,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "text_8",
    transform: "matrix(.1 0 0 -.1 310.168 236.315)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-33",
    id: "use21"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-35",
    id: "use22",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use23",
    x: 127.246
  })))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_17",
    d: "M357.98 221.717V29.894",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mccc559a24d",
    id: "line2d_18",
    x: 357.979,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "text_9",
    transform: "matrix(.1 0 0 -.1 348.436 236.315)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-34",
    d: "M2419 4116 825 1625h1594zm-166 550h794V1625h666v-525h-666V0h-628v1100H313v609z",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-34",
    id: "use24"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use25",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use26",
    x: 127.246
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "text_10",
    transform: "matrix(.1 0 0 -.1 137.385 249.993)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-4e",
    d: "M628 4666h850L3547 763v3903h612V0h-850L1241 3903V0H628Z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-75",
    d: "M544 1381v2119h575V1403q0-497 193-746 194-248 582-248 465 0 735 297 271 297 271 810v1984h575V0h-575v538q-209-319-486-474-276-155-642-155-603 0-916 375-312 375-312 1097m1447 2203",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-6d",
    d: "M3328 2828q216 388 516 572t706 184q547 0 844-383 297-382 297-1088V0h-578v2094q0 503-179 746-178 244-543 244-447 0-707-297-259-296-259-809V0h-578v2094q0 506-178 748t-550 242q-441 0-701-298-259-298-259-808V0H581v3500h578v-544q197 322 472 475t653 153q382 0 649-194 267-193 395-562",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-62",
    d: "M3116 1747q0 634-261 995t-717 361q-457 0-718-361t-261-995 261-995 718-361q456 0 717 361t261 995M1159 2969q182 312 458 463 277 152 661 152 638 0 1036-506 399-506 399-1331T3314 415Q2916-91 2278-91q-384 0-661 152-276 152-458 464V0H581v4863h578z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-65",
    d: "M3597 1894v-281H953q38-594 358-905t892-311q331 0 642 81t618 244V178Q3153 47 2828-22t-659-69q-838 0-1327 487-489 488-489 1320 0 859 464 1363 464 505 1252 505 706 0 1117-455 411-454 411-1235m-575 169q-6 471-264 752-258 282-683 282-481 0-770-272t-333-766z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-72",
    d: "M2631 2963q-97 56-211 82-114 27-251 27-488 0-749-317t-261-911V0H581v3500h578v-544q182 319 472 473 291 155 707 155 59 0 131-8 72-7 159-23z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-6f",
    d: "M1959 3097q-462 0-731-361t-269-989 267-989q268-361 733-361 460 0 728 362 269 363 269 988 0 622-269 986-268 364-728 364m0 487q750 0 1178-488 429-487 429-1349 0-859-429-1349Q2709-91 1959-91q-753 0-1180 489-426 490-426 1349 0 862 426 1349 427 488 1180 488",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-66",
    d: "M2375 4863v-479h-550q-309 0-430-125-120-125-120-450v-309h947v-447h-947V0H697v3053H147v447h550v244q0 584 272 851 272 268 862 268z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-67",
    d: "M2906 1791q0 625-258 968-257 344-723 344-462 0-720-344-258-343-258-968 0-622 258-966t720-344q466 0 723 344 258 344 258 966m575-1357q0-893-397-1329-396-436-1215-436-303 0-572 45t-522 139v559q253-137 500-202 247-66 503-66 566 0 847 295t281 892v285q-178-310-456-463T1784 0Q1141 0 747 490 353 981 353 1791q0 812 394 1302 394 491 1037 491 388 0 666-153t456-462v531h575z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-79",
    d: "M2059-325q-243-625-475-815-231-191-618-191H506v481h338q237 0 368 113 132 112 291 531l103 262L191 3500h609L1894 763l1094 2737h609z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-61",
    d: "M2194 1759q-697 0-966-159t-269-544q0-306 202-486 202-179 548-179 479 0 768 339t289 901v128zm1147 238V0h-575v531q-197-318-491-470T1556-91q-537 0-855 302-317 302-317 808 0 590 395 890 396 300 1180 300h807v57q0 397-261 614t-733 217q-300 0-585-72-284-72-546-216v532q315 122 612 182 297 61 578 61 760 0 1135-394 375-393 375-1193",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-74",
    d: "M1172 4494v-994h1184v-447H1172V1153q0-428 117-550t477-122h590V0h-590q-666 0-919 248-253 249-253 905v1900H172v447h422v994z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-70",
    d: "M1159 525v-1856H581v4831h578v-531q182 312 458 463 277 152 661 152 638 0 1036-506 399-506 399-1331T3314 415Q2916-91 2278-91q-384 0-661 152-276 152-458 464m1957 1222q0 634-261 995t-717 361q-457 0-718-361t-261-995 261-995 718-361q456 0 717 361t261 995",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-73",
    d: "M2834 3397v-544q-243 125-506 187-262 63-544 63-428 0-642-131t-214-394q0-200 153-314t616-217l197-44q612-131 870-370t258-667q0-488-386-773Q2250-91 1575-91q-281 0-586 55T347 128v594q319-166 628-249 309-82 613-82 406 0 624 139 219 139 219 392 0 234-158 359-157 125-692 241l-200 47q-534 112-772 345-237 233-237 639 0 494 350 762 350 269 994 269 318 0 599-47 282-46 519-140",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-4e",
    id: "use27"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-75",
    id: "use28",
    x: 74.805
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-6d",
    id: "use29",
    x: 138.184
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-62",
    id: "use30",
    x: 235.596
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-65",
    id: "use31",
    x: 299.072
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-72",
    id: "use32",
    x: 360.596
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-6f",
    id: "use33",
    x: 433.496
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-66",
    id: "use34",
    x: 494.678
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-66",
    id: "use35",
    x: 561.67
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-6f",
    id: "use36",
    x: 596.875
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-72",
    id: "use37",
    x: 658.057
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-67",
    id: "use38",
    x: 697.42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-65",
    id: "use39",
    x: 760.896
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-72",
    id: "use40",
    x: 822.42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-79",
    id: "use41",
    x: 863.533
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-61",
    id: "use42",
    x: 954.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-74",
    id: "use43",
    x: 1015.779
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-74",
    id: "use44",
    x: 1054.988
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-65",
    id: "use45",
    x: 1094.197
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-6d",
    id: "use46",
    x: 1155.721
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-70",
    id: "use47",
    x: 1253.133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-74",
    id: "use48",
    x: 1316.609
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-73",
    id: "use49",
    x: 1355.818
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-70",
    id: "use50",
    x: 1439.705
  })))), /*#__PURE__*/React.createElement("g", {
    id: "matplotlib.axis_2",
    transform: "translate(.949 -12.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ytick_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_19",
    d: "M51.84 221.717h321.408",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "line2d_20"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m59529f151b",
    d: "M0 0h-3.5",
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m59529f151b",
    id: "use51",
    x: 51.84,
    y: 221.717,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "text_11",
    transform: "matrix(.1 0 0 -.1 28.937 225.516)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-2e",
    d: "M684 794h660V0H684Z",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use52"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-2e",
    id: "use53",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use54",
    x: 95.41
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ytick_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_21",
    d: "M51.84 185.135h321.408",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m59529f151b",
    id: "line2d_22",
    x: 51.84,
    y: 185.135,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "text_12",
    transform: "matrix(.1 0 0 -.1 28.937 188.934)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use55"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-2e",
    id: "use56",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-32",
    id: "use57",
    x: 95.41
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ytick_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_23",
    d: "M51.84 148.553h321.408",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m59529f151b",
    id: "line2d_24",
    x: 51.84,
    y: 148.553,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "text_13",
    transform: "matrix(.1 0 0 -.1 28.937 152.353)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use58"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-2e",
    id: "use59",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-34",
    id: "use60",
    x: 95.41
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ytick_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_25",
    d: "M51.84 111.972h321.408",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m59529f151b",
    id: "line2d_26",
    x: 51.84,
    y: 111.972,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "text_14",
    transform: "matrix(.1 0 0 -.1 28.937 115.77)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-36",
    d: "M2113 2584q-425 0-674-291-248-290-248-796 0-503 248-796 249-292 674-292t673 292q248 293 248 796 0 506-248 796-248 291-673 291m1253 1979v-575q-238 112-480 171-242 60-480 60-625 0-955-422-329-422-376-1275 184 272 462 417 279 145 613 145 703 0 1111-427 408-426 408-1160 0-719-425-1154Q2819-91 2113-91q-810 0-1238 620-428 621-428 1799 0 1106 525 1764t1409 658q238 0 480-47t505-140",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use61"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-2e",
    id: "use62",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-36",
    id: "use63",
    x: 95.41
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ytick_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_27",
    d: "M51.84 75.39h321.408",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m59529f151b",
    id: "line2d_28",
    x: 51.84,
    y: 75.39,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "text_15",
    transform: "matrix(.1 0 0 -.1 28.937 79.19)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-38",
    d: "M2034 2216q-450 0-708-241-257-241-257-662 0-422 257-663 258-241 708-241t709 242q260 243 260 662 0 421-258 662-257 241-711 241m-631 268q-406 100-633 378-226 279-226 679 0 559 398 884 399 325 1092 325 697 0 1094-325t397-884q0-400-227-679-226-278-629-378 456-106 710-416 255-309 255-755 0-679-414-1042Q2806-91 2034-91q-771 0-1186 362-414 363-414 1042 0 446 256 755 257 310 713 416m-231 997q0-362 226-565 227-203 636-203 407 0 636 203 230 203 230 565 0 363-230 566-229 203-636 203-409 0-636-203-226-203-226-566",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use64"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-2e",
    id: "use65",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-38",
    id: "use66",
    x: 95.41
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ytick_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line2d_29",
    d: "M51.84 38.808h321.408",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeWidth: 0.8,
      strokeLinecap: "square"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m59529f151b",
    id: "line2d_30",
    x: 51.84,
    y: 38.808,
    style: {
      stroke: "#000",
      strokeWidth: 0.8
    }
  }), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "text_16",
    transform: "matrix(.1 0 0 -.1 28.937 42.608)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-31",
    id: "use67"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-2e",
    id: "use68",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use69",
    x: 95.41
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "text_17",
    transform: "matrix(0 -.1 -.1 0 22.857 174.198)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-53",
    d: "M3425 4513v-616q-359 172-678 256-319 85-616 85-515 0-795-200t-280-569q0-310 186-468 186-157 705-254l381-78q706-135 1042-474t336-907q0-679-455-1029Q2797-91 1919-91q-331 0-705 75-373 75-773 222v650q384-215 753-325 369-109 725-109 540 0 834 212 294 213 294 607 0 343-211 537t-692 291l-385 75q-706 140-1022 440-315 300-315 835 0 619 436 975t1201 356q329 0 669-60 341-59 697-177",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-63",
    d: "M3122 3366v-538q-244 135-489 202t-495 67q-560 0-870-355-309-354-309-995t309-996q310-354 870-354 250 0 495 67t489 202V134Q2881 22 2623-34q-257-57-548-57-791 0-1257 497-465 497-465 1341 0 856 470 1346 471 491 1290 491 265 0 518-55 253-54 491-163",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-69",
    d: "M603 3500h575V0H603Zm0 1363h575v-729H603Z",
    transform: "scale(.01563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-6c",
    d: "M603 4863h575V0H603Z",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-53",
    id: "use70"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-75",
    id: "use71",
    x: 63.477
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-63",
    id: "use72",
    x: 126.855
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-63",
    id: "use73",
    x: 181.836
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-65",
    id: "use74",
    x: 236.816
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-73",
    id: "use75",
    x: 298.34
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-73",
    id: "use76",
    x: 350.439
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-70",
    id: "use77",
    x: 434.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-72",
    id: "use78",
    x: 497.803
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-6f",
    id: "use79",
    x: 536.666
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-62",
    id: "use80",
    x: 597.848
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-61",
    id: "use81",
    x: 661.324
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-62",
    id: "use82",
    x: 722.604
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-69",
    id: "use83",
    x: 786.08
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-6c",
    id: "use84",
    x: 813.863
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-69",
    id: "use85",
    x: 841.646
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-74",
    id: "use86",
    x: 869.43
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-79",
    id: "use87",
    x: 908.639
  })))), /*#__PURE__*/React.createElement("path", {
    id: "line2d_31",
    d: "m52.605 217.086.766-1.157.765-2.316.765-1.157.766-2.316.765-3.473 1.53-4.63h.766l.765-8.104.766-2.315.765-3.473.766-2.315 1.53-2.316.766-3.473.765-2.315.765-1.158.766-2.315 2.296-3.473h.765l.765-5.788.766-3.473.765-1.158.765-2.315.766-1.158.765-2.315.765-3.473.766-2.315 3.061-4.63h2.296l.766-1.158.765-2.316h.765l.766-2.315h.765l.765-4.63.766-1.158.765-5.788h2.296l.765-1.158h1.531l.765-2.315.766-1.158h.765l.766-2.315.765-1.158h.765l.766-1.158.765-2.315.765-3.473h.766l.765-1.157h.765l2.296-3.473.766-3.473h1.53l1.531-2.316h.765l.766-1.157.765-2.316.765-1.157h.766l.765-3.473h.766l2.296-3.473h1.53l1.53-2.315h.766l2.296-3.473h1.531l2.296-3.473h1.53l2.297-3.473h1.53l.766-2.316h1.53l.766-2.315.765-1.158h2.296l.766-1.157.765-3.473h9.95l1.53-2.315h.766l1.53-2.316h2.296l.766-1.157h1.53l.766-1.158h1.53l1.531-2.315.765-2.316h9.185l.765-1.157h29.083l.766-1.158.765-2.315h2.296l.765-1.158h16.073l.765-1.158h13.01l.766-1.157h3.062l1.53-2.315h30.614l.766-1.158h5.357l.765-1.158h41.33l.765-1.157h39.032",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#1f77b4",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    },
    transform: "translate(.949 -12.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line2d_32",
    d: "m52.605 217.086.766-9.261.765-4.63.765-3.474.766-1.157.765-3.473.765-2.315 2.296-13.892 1.531-11.577.766-2.315.765-4.63.765-2.316.766-6.946.765-5.788.765-3.473.766-4.63 1.53-4.631.766-6.946h.765l.765-3.473.766-2.315.765-3.473.765-1.158.766-2.315 2.296-3.473.765-2.315.765-4.631.766-1.158h.765l1.53-4.63.766-6.946 1.53-2.315h1.532l.765-2.316.765-1.157h.766l.765-3.473h2.296l.765-3.473.766-1.158.765-3.473h.765l2.297-3.473 1.53-4.63 1.53-2.316h3.828l.765-1.157h.765l.766-2.316h3.826l.766-2.315.765-1.158h2.296l2.296-3.473h2.296l.766-1.157h1.53l.766-1.158h.765l.765-2.315h9.185l.765-1.158h6.888l1.53-2.315h5.358l.765-1.158h.766l.765-1.157h10.715l.765-1.158h6.889l.765-1.158h192.102",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#ff7f0e",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    },
    transform: "translate(.949 -12.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line2d_33",
    d: "m52.605 203.194.766-19.68.765-15.049 1.53-32.414 2.297-31.257.765-4.63.765-8.104.766-4.63.765-2.316.766-3.473.765-5.788.765-1.158.766-4.63.765-5.788.765-2.316.766-1.157.765-4.631 1.53-2.315.766-2.316 1.53-2.315 1.531-4.63h.766l.765-2.316.765-1.157h10.715l.766-1.158h2.296l.765-1.158H357.98",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#2ca02c",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    },
    transform: "translate(.949 -12.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line2d_34",
    d: "m52.605 169.623.766-30.1 1.53-49.778 1.531-19.68.765-5.788.766-4.631.765-3.473 1.53-4.63.766-3.474h.766l.765-2.315.765-1.157h.766l2.296-3.473.765-2.316h290.832",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#d62728",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    },
    transform: "translate(.949 -12.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line2d_35",
    d: "m52.605 132.578.766-59.04.765-18.523.765-11.576 2.296-3.473h1.531l.765-1.158H357.98",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#9467bd",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    },
    transform: "translate(.949 -12.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line2d_36",
    d: "m52.605 65.434.766-20.837.765-5.789h303.843",
    clipPath: "url(#p4bca49a77d)",
    style: {
      fill: "none",
      stroke: "#8c564b",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    },
    transform: "translate(.949 -12.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "patch_3",
    d: "M52.789 209.037V17.214",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "patch_4",
    d: "M374.197 209.037V17.214",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "patch_5",
    d: "M52.789 209.037h321.408",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "patch_6",
    d: "M52.789 17.214h321.408",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.8,
      strokeLinecap: "square",
      strokeLinejoin: "miter"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "legend_1",
    transform: "translate(.949 -12.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "patch_7",
    d: "M315.16 216.717h51.088q2 0 2-2V112.97q0-2-2-2h-51.087q-2 0-2 2v101.747q0 2 2 2z",
    style: {
      opacity: 0.8,
      fill: "#fff",
      stroke: "#ccc",
      strokeLinejoin: "miter"
    }
  }), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "text_18",
    transform: "matrix(.1 0 0 -.1 337.53 122.568)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DejaVuSans-71",
    d: "M947 1747q0-634 261-995t717-361 718 361q263 361 263 995t-263 995q-262 361-718 361t-717-361-261-995M2906 525q-181-312-458-464-276-152-664-152-634 0-1033 506-398 507-398 1332t398 1331q399 506 1033 506 388 0 664-152 277-151 458-463v531h575v-4831h-575z",
    transform: "scale(.01563)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-71",
    id: "use88"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "line2d_37",
    d: "M317.16 133.746h20",
    style: {
      fill: "none",
      stroke: "#1f77b4",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    }
  }), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "text_19",
    transform: "matrix(.1 0 0 -.1 345.16 137.246)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-31",
    id: "use89"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-32",
    id: "use90",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-38",
    id: "use91",
    x: 127.246
  }))), /*#__PURE__*/React.createElement("path", {
    id: "line2d_38",
    d: "M317.16 148.425h20",
    style: {
      fill: "none",
      stroke: "#ff7f0e",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    }
  }), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "text_20",
    transform: "matrix(.1 0 0 -.1 345.16 151.925)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-31",
    id: "use92"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-36",
    id: "use93",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use94",
    x: 127.246
  }))), /*#__PURE__*/React.createElement("path", {
    id: "line2d_39",
    d: "M317.16 163.103h20",
    style: {
      fill: "none",
      stroke: "#2ca02c",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    }
  }), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "text_21",
    transform: "matrix(.1 0 0 -.1 345.16 166.603)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-32",
    id: "use95"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-34",
    id: "use96",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use97",
    x: 127.246
  }))), /*#__PURE__*/React.createElement("path", {
    id: "line2d_40",
    d: "M317.16 177.78h20",
    style: {
      fill: "none",
      stroke: "#d62728",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    }
  }), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "text_22",
    transform: "matrix(.1 0 0 -.1 345.16 181.28)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-33",
    id: "use98"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-32",
    id: "use99",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use100",
    x: 127.246
  }))), /*#__PURE__*/React.createElement("path", {
    id: "line2d_41",
    d: "M317.16 192.459h20",
    style: {
      fill: "none",
      stroke: "#9467bd",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    }
  }), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "text_23",
    transform: "matrix(.1 0 0 -.1 345.16 195.959)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-34",
    id: "use101"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-38",
    id: "use102",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use103",
    x: 127.246
  }))), /*#__PURE__*/React.createElement("path", {
    id: "line2d_42",
    d: "M317.16 207.137h20",
    style: {
      fill: "none",
      stroke: "#8c564b",
      strokeWidth: 1.5,
      strokeLinecap: "square"
    }
  }), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "text_24",
    transform: "matrix(.1 0 0 -.1 345.16 210.637)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-38",
    id: "use104"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use105",
    x: 63.623
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#DejaVuSans-30",
    id: "use106",
    x: 127.246
  })))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs106"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "p4bca49a77d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M51.84 29.894h321.408v191.822H51.84Z"
  })))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text1",
    x: 35.896,
    y: 14.166,
    style: {
      fontSize: "15.5277px",
      fill: "#000",
      strokeWidth: 1.29397
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1",
    x: 35.896,
    y: 14.166,
    style: {
      strokeWidth: 1.29397
    }
  }, "SPHINCS-PLUS Attack Performance")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNumFaultComparison2);
export default __webpack_public_path__ + "static/media/myNumFaultComparison_2.a1122c090212a0605be1ddef54fafa47.svg";
export { ForwardRef as ReactComponent };